module.exports = __webpack_public_path__ + "static/media/ico_whatsapp_white.ade3c3b6.svg";